export function pascalCase(input: string) {
  if (input.length === 0) {
    return "";
  }
  return (
    input.charAt(0).toUpperCase() +
    input.substring(1, input.length).toLowerCase()
  );
}
